import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from "@remix-run/react";
import { getValidDate } from '../../pages/TvGuidePage/tv-guide-helpers';
import { slugTomorrow } from '../../pages/TvGuidePage/TvGuidePage.route';
import { isoDate } from '../../utils/date-formatter';
export const useTvGuideDate = () => {
  const {
    isoDate: isoDateParam
  } = useParams();
  const {
    t
  } = useTranslation();
  const fallbackVersion = isoDateParam === slugTomorrow(t) ? 'tomorrow' : 'today';
  const [date, setDate] = useState(getValidDate(isoDateParam, fallbackVersion));
  useEffect(() => {
    const urlDate = getValidDate(isoDateParam, fallbackVersion);
    setDate(currentDate => isoDate(urlDate) === isoDate(currentDate) ? currentDate : urlDate);
  }, [fallbackVersion, isoDateParam]);
  return {
    date,
    setDate
  };
};